module.exports = __webpack_public_path__ + "static/image/SDPA.svg?e6bef96f457c1bc339a80e388edcfbf4";